// import axios from "axios";
import apiClient from "../plugins/axios-instance";
import Properties from "../properties";

const API_URL =
  "https://backend." + Properties.DOMAIN_URL + "/merchant-api/api/kontrak-merchants";

export default class KontrakMerchantAPIService {
  constructor() { }
  config = this.$session.get("jwt");

  static current = (body) => {
    return apiClient.get(API_URL + "/latest", {
      params: body,
    });
  };

  static getList = (body) => {
    return apiClient.get(API_URL + "/get-list", {
      params: body,
    });
  };

  static edit = (id, kontrak) =>
    apiClient.post(API_URL + "/" + id, kontrak, {
    });

  static create = (kontrak) =>
    apiClient.post(API_URL + "/", kontrak, {
    });

  static delete = (kode, nik) =>
    apiClient.delete(API_URL + "/" + kode, {
      params: {
        user_update: nik,
      },
    });
}
